import React, { useEffect, useState } from "react";
import { Button } from "@pushpress/shared-components";
import { ButtonProps } from "@pushpress/shared-components/build/components/buttons/Button";

type TextChangingButtonProps = Omit<ButtonProps<"button">, "ref">;

const SHOW_LOADING_TIME = 500;

function TextChangingButton(props: TextChangingButtonProps) {
  const { text, loading, ...other } = props;

  const [textInternal, setTextInternal] = useState(text);

  const [changing, setChanging] = useState(false);

  useEffect(() => {
    if (text === textInternal) return;
    setChanging(true);
    setTimeout(() => {
      setTextInternal(text);
      setChanging(false);
    }, SHOW_LOADING_TIME);
  }, [text, textInternal]);

  return (
    <Button {...other} loading={loading || changing} text={textInternal} />
  );
}

export default TextChangingButton;
